import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {
  @Input() name: string;
  @Input() round: boolean = true;
  @Input() textSizeRatio: number = 2.5;
  @Input() size: number = 40;
  @Input() saturation = 50;
  @Input() lightness = 40;
  reducedName: string;

  constructor() {
  }

  ngOnInit(): void {
    this.reducedName = this.name.indexOf(' ') === -1 ?
      this.reducedName.slice(0, 2).toUpperCase() :
      this.name.split(' ').slice(0, 2).map(s => s.slice(0, 1)).join('').toUpperCase();
  }

  stringToHslColor(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      // tslint:disable-next-line:no-bitwise
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    return 'hsl(' + h + ', ' + this.saturation + '%, ' + this.lightness + '%)';
  }
}
